export default __webpack_public_path__ + "static/girnaldas-388ba9fffd7878c839e5245d7996f256.png";